import Wrapper from "../../../layout/Wrapper";
import ContractComponent from "../../../screens/contractControll/checkVehicleContract/Index";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Contract Management",
	description: "",
};

export default function Contract() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<ContractComponent />
		</Wrapper>
	);
}